<template>
	<div class="progress-avatar-box" :style="{ width: size + 'px', height: size + 'px' }">
		<svg class="progress-ring" :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
			<circle class="progress-ring__background"
			        :cx="center" :cy="center" :r="radius"
			        fill="transparent"
			        stroke="var(--white-color, #ffffff)"
			        stroke-width="1"/>
			<circle class="progress-ring__circle"
			        :cx="center" :cy="center" :r="radius"
			        fill="transparent"
			        stroke="var(--primary-color)"
			        stroke-width="1"
			        stroke-linecap="round"
			        :stroke-dasharray="progressCircumference"
			        :stroke-dashoffset="progressOffset"
			        :transform="`rotate(-90 ${center} ${center})`"/>
		</svg>
		<div class="avatar-content" :class="$store.state.auth.syncThreshold !== 0 && syncPercentage < 100 ? 'loading': ''" :style="{ width: (size - 2) + 'px', height: (size - 2) + 'px' }">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProgressAvatarBox",
	props: {
		size: {
			type: Number,
			default: 0
		}
	},
	computed: {
		center() {
			return this.size / 2;
		},
		radius() {
			return (this.size - 2) / 2;
		},
		syncPercentage() {
			return this.$store.state.auth.syncPercentage || 0;
		},
		progressCircumference() {
			return 2 * Math.PI * this.radius;
		},
		progressOffset() {
			const circumference = this.progressCircumference;
			return circumference - (this.syncPercentage / 100) * circumference;
		}
	}
}
</script>

<style scoped lang="scss">
.progress-avatar-box {
	position: relative;

	.progress-ring {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		pointer-events: none;

		.progress-ring__circle {
			transition: stroke-dashoffset 0.5s ease-in-out;
		}
	}

	.avatar-content {
		position: absolute;
		top: 1px;
		left: 1px;
		border-radius: 100%;
		overflow: hidden;
		display: block;
		z-index: 1;
		&:before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			border-radius: 100%;
			overflow: hidden;
			background-color: rgba(0, 0, 0, 0.75);
			opacity: 0;
			transition: var(--animation-default-duration, $animationDefaultDuration);
			z-index: 1;
			pointer-events: none;
		}
		&:after {
			content: "\1f5d8";
			font-weight: 300;
			font-family: "Font Awesome 6 Pro";
			-moz-osx-font-smoothing: grayscale;
			-webkit-font-smoothing: antialiased;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			font-size: 16px;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			transition: var(--animation-default-duration, $animationDefaultDuration);
			z-index: 2;
			animation: spinning_animation 2s infinite linear;
			pointer-events: none;
			color: var(--white-color, $whiteColor);
		}
		&.loading {
			&:before,
			&:after {
				opacity: 1;
			}
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 100%;
			padding: 2px;
		}

		a {
			display: block;
			width: 100%;
			height: 100%;
		}
	}
}
</style>